export default __webpack_public_path__ + "static/media/group-admin.0e2baacc.svg";